import { isEmpty, isNil } from 'lodash'

import {
	entityToLabelValue,
	personEntityToLabelValue,
	requiredFieldLabel
} from 'Core/utils/dataFormat'
import { formatStateProvinceToLabelValue } from 'Core/utils/storeHelpers'
import { StateProvince } from 'Core/utils/storeHelpers/types'

export const getLabel = (isRequired: boolean, label: string) =>
	isRequired ? requiredFieldLabel(label) : label

export const getLabelValue = (entity: Nullable<Entity>): LabelValue<number> | null =>
	!isNil(entity) ? entityToLabelValue(entity) : null

export const getLabelValues = (entities: Nullable<Entity[]>): LabelValue<number>[] =>
	isNil(entities) || isEmpty(entities) ? [] : entities.map(entityToLabelValue)

export const getStateProvinceLabelValue = (state: Nullable<StateProvince>): LabelValue | null =>
	state ? formatStateProvinceToLabelValue(state) : null

export const getContactLabelValue = <T extends { id: number; firstName: string; lastName: string }>(
	entity: Nullable<T>
): LabelValue<number> | null => (!isNil(entity) ? personEntityToLabelValue(entity) : null)
